export default __webpack_public_path__ + "static/media/poster-background.c03b16ef.png";